import '../icon';
import '../text';
import '../title';
import { defineCustomElement, getAttribute, getBooleanAttribute, getLiteralAttribute, isAttrEqual, isAttrTrue, NectaryElement, updateAttribute, updateBooleanAttribute, updateExplicitBooleanAttribute, updateLiteralAttribute } from '../utils';
const templateHTML = '<style>:host{display:block;outline:0;min-height:48px}#wrapper{display:flex;flex-direction:column;position:relative;width:100%;height:100%;box-sizing:border-box;overflow:hidden;border-bottom:1px solid var(--sinch-comp-accordion-color-default-border-initial)}:host(:last-child)>#wrapper{border-bottom:none}#button{all:initial;display:flex;position:relative;align-items:center;gap:8px;box-sizing:border-box;width:100%;height:48px;padding:0 4px 0 8px;cursor:pointer;--sinch-global-color-icon:var(--sinch-comp-accordion-color-default-icon-initial);--sinch-global-size-icon:var(--sinch-comp-accordion-size-icon)}#button>*{pointer-events:none}#button:disabled{cursor:initial;--sinch-global-color-icon:var(--sinch-comp-accordion-color-disabled-icon-initial)}#button:focus-visible::after{content:"";position:absolute;inset:0;border:2px solid var(--sinch-comp-accordion-color-default-outline-focus);pointer-events:none}#status-wrapper{display:none;width:18px;height:24px;padding:8px 8px 8px 2px;box-sizing:border-box}#status{width:8px;height:8px;border-radius:50%}:host([status]:not([status=""])) #status-wrapper{display:block}:host([status=success]) #status{background-color:var(--sinch-comp-accordion-color-default-status-success)}:host([status=warn]) #status{background-color:var(--sinch-comp-accordion-color-default-status-warning)}:host([status=error]) #status{background-color:var(--sinch-comp-accordion-color-default-status-error)}:host([status=info]) #status{background-color:var(--sinch-comp-accordion-color-default-status-info)}#title{flex:1;min-width:0;--sinch-comp-title-font:var(--sinch-comp-accordion-font-title);--sinch-global-color-text:var(--sinch-comp-accordion-color-default-title-initial)}#button:disabled>#title{--sinch-global-color-text:var(--sinch-comp-accordion-color-disabled-title-initial)}#content{display:none;overflow-y:auto;flex-shrink:1;min-height:0;padding:0 8px 12px}#dropdown-icon{transform:rotate(0);will-change:transform;transition:transform .25s ease-in-out}#button[aria-expanded=true]>#dropdown-icon{transform:rotate(180deg)}#button[aria-expanded=true]+#content{display:block}#optional{--sinch-comp-text-font:var(--sinch-comp-accordion-font-optional-text);--sinch-global-color-text:var(--sinch-comp-accordion-color-default-optional-text-initial)}#button:disabled>#optional{--sinch-global-color-text:var(--sinch-comp-accordion-color-disabled-optional-text-initial)}</style><div id="wrapper"><button id="button" aria-controls="content" aria-expanded="false"><div id="status-wrapper"><div id="status"></div></div><slot name="icon"></slot><sinch-title id="title" level="3" type="m" ellipsis></sinch-title><sinch-text id="optional" type="m"></sinch-text><sinch-icon id="dropdown-icon" name="keyboard_arrow_down"></sinch-icon></button><div id="content" role="region" aria-labelledby="button"><slot name="content"></slot></div></div>';
import { statusValues } from './utils';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-accordion-item', class extends NectaryElement {
  #$button;
  #$title;
  #$optionalText;
  constructor() {
    super();
    const shadowRoot = this.attachShadow({
      delegatesFocus: true
    });
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$button = shadowRoot.querySelector('#button');
    this.#$title = shadowRoot.querySelector('#title');
    this.#$optionalText = shadowRoot.querySelector('#optional');
  }
  connectedCallback() {}
  disconnectedCallback() {}
  static get observedAttributes() {
    return ['label', 'disabled', 'data-checked', 'optionaltext'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    if (isAttrEqual(oldVal, newVal)) {
      return;
    }
    switch (name) {
      case 'label':
        {
          updateAttribute(this.#$title, 'text', newVal);
          break;
        }
      case 'disabled':
        {
          this.#$button.disabled = isAttrTrue(newVal);
          updateBooleanAttribute(this, name, isAttrTrue(newVal));
          break;
        }
      case 'data-checked':
        {
          updateExplicitBooleanAttribute(this.#$button, 'aria-expanded', isAttrTrue(newVal));
          break;
        }
      case 'optionaltext':
        {
          this.#$optionalText.textContent = newVal;
          break;
        }
    }
  }
  set value(value) {
    updateAttribute(this, 'value', value);
  }
  get value() {
    return getAttribute(this, 'value', '');
  }
  set label(value) {
    updateAttribute(this, 'label', value);
  }
  get label() {
    return getAttribute(this, 'label', '');
  }
  set disabled(isDisabled) {
    updateBooleanAttribute(this, 'disabled', isDisabled);
  }
  get disabled() {
    return getBooleanAttribute(this, 'disabled');
  }
  get status() {
    return getLiteralAttribute(this, statusValues, 'status', null);
  }
  set status(value) {
    updateLiteralAttribute(this, statusValues, 'status', value);
  }
  set optionalText(value) {
    updateAttribute(this, 'optionaltext', value);
  }
  get optionalText() {
    return getAttribute(this, 'optionaltext');
  }
  get focusable() {
    return true;
  }
  focus() {
    this.#$button.focus();
  }
  blur() {
    this.#$button.blur();
  }
});